import idbs from '@/data/indexedDBService'
import DataMain from '@/data/dataMain'
import API from '@/data/api.js'
import {store} from '@/store'

const DataUser = {
  async notificationSubscribe (subscription) {
    try {
      let params = {
        apiParams: {
          subscription: subscription
        },
        slug: 'api/subscription'
      }
      await API.getData(params)
    } catch (err) {
      console.log(err)
    }
  },
  async notificationUnsubscribe (endpoint) {
    try {
      let params = {
        apiParams: {
          endpoint: endpoint
        },
        slug: 'api/subscription/delete'
      }
      await API.getData(params)
    } catch (err) {
      console.log(err)
    }
  },

  async setData (data) {
    let params = {
      storeInfo: {
        action: 'setUserInfo',
        params: {
          isAdmin: data.isAdmin
        }
      },
      idbInfo: {
        store: 'user',
        storeKey: 'user',
        indexName: 'key',
        key: 'permissions',
        params: {
          key: 'permissions',
          isAdmin: data.isAdmin
        }
      }
    }
    DataMain.setData(params)
  },

  async getUserData () {
    let user = await idbs.getItem('user', 'key', 'permissions')
    let payload = {}
    if (user && user.isAdmin) {
      payload.isAdmin = user.isAdmin
    }
    store.commit('setUserInfo', payload)
  }
}

export default DataUser



// WEBPACK FOOTER //
// ./src/data/controllers/DataUser.js